const isFeatureEnabled = ({ featureState }, featureName) => {
  return featureState[featureName];
};

export { isFeatureEnabled };
